import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ReactElement, useContext, useState } from "react";

import useUpdateAsset from "../../hooks/mutation/category/use-update-asset";
import Title from "../../pages/detail-page/parts/title";
import { CategoryContext } from "../../providers/category-provider";
import { Flatten, flatten } from "../../utils/flatten";

type Props = {
  assetId: string;
  selectedCategoryId: string;
};

export default function CategorySelector(props: Props): ReactElement {
  const { selectedCategoryId, assetId } = props;
  const { categories } = useContext(CategoryContext);

  const { updateAsset } = useUpdateAsset();

  const [submittingCategory, setSubmittingCategory] = useState(false);

  // Collect categories structure
  const categoriesItems = [];

  categoriesItems.push(
    <MenuItem key="default" value="">
      <em>None</em>
    </MenuItem>
  );

  flatten(
    categories.map((v): Flatten => {
      return {
        id: v.id,
        parent_id: v.parentId || undefined,
        name: v.name || "",
      };
    })
  ).map((item: Flatten) => {
    categoriesItems.push(
      <MenuItem className="text-[12px]" key={item.id} value={item.id}>
        {item.name}
      </MenuItem>
    );

    if (item.children) {
      item.children.map((family: Flatten) => {
        categoriesItems.push(
          <MenuItem
            className="text-[12px] pl-[30px]"
            key={family.id}
            value={family.id}
          >
            {family.name}
          </MenuItem>
        );

        if (family.children) {
          family.children.map((product: Flatten) => {
            categoriesItems.push(
              <MenuItem
                className="text-[12px] pl-[45px]"
                key={product.id}
                value={product.id}
              >
                {product.name}
              </MenuItem>
            );
          });
        }
      });
    }
  });

  async function onSelectCategory(
    value: SelectChangeEvent<string>
  ): Promise<void> {
    const category = categories.find((v) => v.id === value.target.value);
    if (!category) {
      // eslint-disable-next-line no-console
      console.info(`no category with id ${value}.`);
      return;
    }

    setSubmittingCategory(true);
    try {
      await updateAsset(assetId, {
        category_id: category.id,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setSubmittingCategory(false);
    }
  }

  return (
    <div className="text-16 mb-[40px]">
      <Title>Category</Title>
      <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
        <Select
          className="border-0 rounded-[15px] text-[14px] text-left m-0"
          defaultValue={selectedCategoryId}
          value={selectedCategoryId}
          disabled={submittingCategory}
          onChange={onSelectCategory}
        >
          {categoriesItems}
        </Select>
      </FormControl>
    </div>
  );
}
